<div class="main-content table-page cierre-bsc">
  <div class="container-fluid">
    <nav class="bsc-migas" aria-label="Ruta de navegación">
      <ng-container *ngIf="desdeArea; else desdeMiBsc">
        <a [routerLink]="ruta.tablero" [queryParams]="{ anio: anio }">Tablero BSC</a>
        <span aria-hidden="true">›</span>
        <a *ngIf="idBscArea != null; else areaSinEnlace" [routerLink]="[ruta.area, idBscArea]" [queryParams]="queryArea">
          {{ nombreArea }} {{ anio }}
        </a>
        <ng-template #areaSinEnlace><span>Detalle de área</span></ng-template>
      </ng-container>
      <ng-template #desdeMiBsc>
        <a [routerLink]="ruta.tablero" [queryParams]="{ anio: anio }" *ngIf="verTablero; else sinTablero">BSC</a>
        <ng-template #sinTablero><span>BSC</span></ng-template>
        <span aria-hidden="true">›</span>
        <a [routerLink]="ruta.miBsc" [queryParams]="queryMiBsc">Mi BSC</a>
      </ng-template>
      <span aria-hidden="true">›</span>
      <span aria-current="page">Cierre de Q{{ q }}</span>
    </nav>

    <section class="table-page__hero cierre-bsc__hero">
      <div class="table-page__copy">
        <h1>{{ titulo }}</h1>
        <p>{{ subtitulo }}</p>
      </div>
      <div class="table-page__toolbar-actions cierre-bsc__pasos"
           *ngIf="estado === 'DATOS' && modo !== 'NO_DISPONIBLE'">
        <ol class="bsc-pasos" aria-label="Pasos del cierre">
          <li *ngFor="let p of pasos" [class.is-hecho]="hecho(p.numero)" [class.is-actual]="actual(p.numero)"
              [attr.aria-current]="actual(p.numero) ? 'step' : null">
            <span class="bsc-pasos__num" aria-hidden="true">
              <span class="material-icons" *ngIf="hecho(p.numero); else numeroPaso">check</span>
              <ng-template #numeroPaso>{{ p.numero }}</ng-template>
            </span>
            {{ p.texto }}<span class="bsc-oculto" *ngIf="hecho(p.numero)">, hecho</span>
          </li>
        </ol>
      </div>
    </section>

    <!-- ============================ Cargando y error ============================ -->
    <section class="table-page__card cierre-bsc__vacio" *ngIf="estado === 'CARGANDO'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando el trimestre</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card cierre-bsc__vacio" *ngIf="estado === 'ERROR'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudo abrir el cierre del trimestre</h3>
        <p>{{ error }}</p>
        <div class="cierre-bsc__vacio-acciones">
          <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" [routerLink]="ruta.miBsc">
            <span class="material-icons" aria-hidden="true">arrow_back</span>
            Ir a Mi BSC
          </a>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" *ngIf="idEjercicio != null"
                  (click)="consultar()">
            <span class="material-icons" aria-hidden="true">refresh</span>
            Volver a consultar
          </button>
        </div>
      </div>
    </section>

    <ng-container *ngIf="estado === 'DATOS'">
      <!-- Lo último que se guardó o se envió. La región existe siempre: así se anuncia al llegar. -->
      <output class="cierre-bsc__estado d-block" aria-live="polite">
        <div class="bsc-franja cierre-bsc__guardado" *ngIf="mensajeGuardado">
          <span class="material-icons" aria-hidden="true">check_circle</span>
          <span>{{ mensajeGuardado }}</span>
        </div>
      </output>

      <output class="bsc-franja cierre-bsc__regreso" *ngIf="regreso && modo === 'CIERRE'">
        <span class="material-icons" aria-hidden="true">undo</span>
        <span>{{ regreso }}</span>
      </output>

      <div class="bsc-franja cierre-bsc__nota-captura" *ngIf="notaCaptura && paso !== 3">
        <span class="material-icons" aria-hidden="true">info</span>
        <span>
          {{ notaCaptura }}
          <a class="table-page__link" *ngIf="viaExcel && puedeCargarExcel" [routerLink]="ruta.cargaExcel"
             [queryParams]="{ modo: 'AVANCES', anio: anio }">Cargar Excel</a>
        </span>
      </div>

      <!-- ============================ No disponible ============================ -->
      <section class="table-page__card cierre-bsc__vacio" *ngIf="modo === 'NO_DISPONIBLE'" aria-labelledby="cierre-bsc-no">
        <div class="table-page__empty">
          <span class="material-icons" aria-hidden="true">lock_clock</span>
          <h3 id="cierre-bsc-no">
            {{ ejercicio?.estatus !== "AUTORIZADA" ? "La planeación todavía no está autorizada"
              : historica ? "Q" + q + " no tiene datos" : "Q" + q + " todavía no se abre a cierre" }}
          </h3>
          <!-- El primer faltante es el porqué; lo demás (meses, real) no aplica todavía. -->
          <p [attr.title]="faltantes[0]?.codigo || null">{{ faltantes[0]?.texto || "Este trimestre no se puede cerrar ahora." }}</p>
          <p *ngIf="trimestre?.estatus === 'PENDIENTE' && !historica && ejercicio?.estatus === 'AUTORIZADA'">
            Sus meses ya se pueden capturar en Mi BSC.
          </p>
          <a mat-raised-button class="btn table-page__primary-btn" [routerLink]="ruta.miBsc" [queryParams]="queryMiBsc">
            <span class="material-icons" aria-hidden="true">arrow_back</span>
            Volver a Mi BSC
          </a>
        </div>
        <!-- Lo que el servidor avisó al leer (un bloque que no se leyó, por ejemplo). -->
        <div class="bsc-mensajes bsc-mensajes--aviso" *ngIf="avisos.length > 0">
          <h3>
            <span class="material-icons" aria-hidden="true">info</span>
            Para tomar en cuenta
          </h3>
          <ul>
            <li *ngFor="let a of avisos; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
          </ul>
        </div>
      </section>

      <!-- ============================ 1 · Meses revisados ============================ -->
      <section class="table-page__card bsc-bloque cierre-bsc__paso" *ngIf="modo === 'CIERRE' && paso === 1"
               aria-labelledby="cierre-bsc-paso-1">
        <header class="bsc-bloque__encabezado bsc-bloque__encabezado--acciones">
          <div>
            <h2 id="cierre-bsc-paso-1" tabindex="-1">1 · Meses de Q{{ q }}</h2>
            <p>
              Cada KPI vigente lleva la actividad o la evidencia de sus tres meses. Revisa lo capturado{{ capturaHabilitada
                ? " y captura lo que falte" : "" }}; los KPI que todavía no aplican se listan, pero no cuentan.
            </p>
          </div>
          <div class="cierre-bsc__conteo">
            <strong>{{ mesesVigentes - mesesFaltantes }} de {{ mesesVigentes }}</strong>
            <span>meses capturados</span>
          </div>
        </header>

        <div class="table-page__table-wrap cierre-bsc__tabla-wrap" *ngIf="filasMeses.length > 0; else sinKpis">
          <table class="table-page__table cierre-bsc__tabla cierre-bsc__tabla--meses">
            <caption class="bsc-oculto">Meses de Q{{ q }} {{ anio }} de {{ nombreArea }} por KPI</caption>
            <thead>
              <tr>
                <th scope="col" class="cierre-bsc__col-objetivo">KPI</th>
                <th scope="col" class="cierre-bsc__col-mes" *ngFor="let m of meses">{{ nombreDeMes(m) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of filasMeses; trackBy: trackFila" [class.is-na]="!f.vigente"
                  [class.is-pendiente]="f.vigente && f.faltan > 0">
                <th scope="row" class="cierre-bsc__col-objetivo">
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ f.objetivo }}</strong>
                    <span class="table-page__subtext" *ngIf="f.nota">{{ f.nota }}</span>
                  </div>
                </th>
                <td class="cierre-bsc__col-mes" *ngFor="let c of f.meses; trackBy: trackCelda"
                    [attr.data-celda]="f.idEjercicioKpi + '-' + c.mes">
                  <div class="cierre-bsc__mes">
                    <span class="table-page__status-badge" *ngIf="c.estado" [ngClass]="c.estado.clase">
                      <span class="material-icons" aria-hidden="true">{{ c.estado.icono }}</span>
                      {{ c.estado.texto }}
                    </span>
                    <span class="cierre-bsc__mes-detalle">{{ c.detalle }}</span>
                    <span class="cierre-bsc__mes-texto" *ngIf="c.resumen">{{ c.resumen }}</span>
                    <button type="button" class="table-page__link cierre-bsc__accion" *ngIf="capturaHabilitada"
                            [disabled]="loading" (click)="capturarMes(f.idEjercicioKpi, c.mes)"
                            [attr.aria-label]="(c.capturado ? 'Editar ' : 'Capturar ') + textoMes(c.mes) + ' de ' + f.objetivo">
                      {{ c.capturado ? "Editar" : "Capturar" }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <footer class="cierre-bsc__pie">
          <span class="cierre-bsc__pie-texto" [class.is-error]="!puedeSeguirMeses && mesesFaltantes > 0"
                [class.is-aviso]="puedeSeguirMeses && mesesFaltantes > 0" id="cierre-bsc-razon-1">
            {{ textoPasoMeses }}
          </span>
          <div class="cierre-bsc__pie-acciones">
            <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
               *ngIf="!desdeArea; else volverArea" [routerLink]="ruta.miBsc" [queryParams]="queryMiBsc">
              <span class="material-icons" aria-hidden="true">arrow_back</span>
              Mi BSC
            </a>
            <button type="button" mat-raised-button class="btn table-page__primary-btn" [disabled]="!puedeSeguirMeses"
                    aria-describedby="cierre-bsc-razon-1" (click)="aAvance()">
              Continuar al avance real
              <span class="material-icons" aria-hidden="true">arrow_forward</span>
            </button>
          </div>
        </footer>
      </section>

      <!-- ============================ 2 · Avance real por KPI ============================ -->
      <section class="table-page__card bsc-bloque cierre-bsc__paso" *ngIf="modo === 'CIERRE' && paso === 2"
               aria-labelledby="cierre-bsc-paso-2">
        <header class="bsc-bloque__encabezado">
          <h2 id="cierre-bsc-paso-2" tabindex="-1">2 · Avance real de Q{{ q }} por KPI</h2>
          <p>
            El avance real y el programado del trimestre en %, y un resumen de la evidencia (el comentario del avance).
            Ponderado y acumulado se calculan con lo que escribes; el servidor los vuelve a calcular al guardar.
          </p>
        </header>

        <div class="table-page__table-wrap cierre-bsc__tabla-wrap" *ngIf="filasAvance.length > 0; else sinKpis">
          <table class="table-page__table cierre-bsc__tabla cierre-bsc__tabla--avance">
            <caption class="bsc-oculto">Avance real de Q{{ q }} {{ anio }} de {{ nombreArea }} por KPI</caption>
            <thead>
              <tr>
                <th scope="col" class="cierre-bsc__col-objetivo">KPI</th>
                <th scope="col" class="cierre-bsc__num cierre-bsc__col-campo">Programado</th>
                <th scope="col" class="cierre-bsc__num cierre-bsc__col-campo">Avance real Q{{ q }}</th>
                <th scope="col" class="cierre-bsc__num cierre-bsc__col-dato">Peso</th>
                <th scope="col" class="cierre-bsc__num cierre-bsc__col-dato">Ponderado</th>
                <th scope="col" class="cierre-bsc__num cierre-bsc__col-dato">Acum. Q{{ q }}</th>
                <th scope="col" class="cierre-bsc__col-evidencia">Resumen de evidencia del trimestre</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of filasAvance; trackBy: trackFila" [class.is-na]="!f.vigente"
                  [class.is-bajo]="f.vigente && f.bajoMeta && !f.error" [class.is-error]="!!f.error">
                <th scope="row" class="cierre-bsc__col-objetivo">
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ f.objetivo }}</strong>
                    <span class="table-page__subtext" *ngIf="f.nota">{{ f.nota }}</span>
                    <span class="cierre-bsc__fila-error" *ngIf="f.error" role="alert">{{ f.error }}</span>
                    <ul class="cierre-bsc__fila-avisos" *ngIf="f.avisos.length > 0">
                      <li *ngFor="let a of f.avisos; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
                    </ul>
                  </div>
                </th>

                <!-- Programado (J) -->
                <td class="cierre-bsc__num cierre-bsc__col-campo">
                  <ng-container *ngIf="f.vigente && capturaHabilitada; else programadoLectura">
                    <mat-form-field appearance="outline" class="table-page__field cierre-bsc__celda" subscriptSizing="dynamic">
                      <input matInput class="cierre-bsc__input-num" [id]="'cierre-bsc-programado-' + f.idEjercicioKpi"
                             inputmode="decimal" autocomplete="off" [(ngModel)]="f.programado" (ngModelChange)="cambia(f)"
                             [disabled]="guardando || loading" placeholder="100"
                             [attr.aria-label]="'Programado de Q' + q + ' (%) de ' + f.objetivo" />
                      <span matTextSuffix>%</span>
                      <mat-hint *ngIf="f.ayudaProgramado" [class.is-aviso]="f.avisoProgramado">{{ f.ayudaProgramado }}</mat-hint>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #programadoLectura>
                    <span class="table-page__text cierre-bsc__apagado">
                      {{ f.vigente ? (f.programadoInicial ? f.programadoInicial + "%" : "—") : "NA" }}
                    </span>
                  </ng-template>
                </td>

                <!-- Avance real (I) -->
                <td class="cierre-bsc__num cierre-bsc__col-campo">
                  <ng-container *ngIf="f.vigente && capturaHabilitada; else realLectura">
                    <mat-form-field appearance="outline" class="table-page__field cierre-bsc__celda" subscriptSizing="dynamic"
                                    [class.is-bajo]="f.bajoMeta">
                      <input matInput class="cierre-bsc__input-num" [id]="'cierre-bsc-real-' + f.idEjercicioKpi"
                             inputmode="decimal" autocomplete="off" [(ngModel)]="f.real" (ngModelChange)="cambia(f)"
                             [disabled]="guardando || loading" placeholder="p. ej. 90"
                             [attr.aria-label]="'Avance real de Q' + q + ' (%) de ' + f.objetivo" />
                      <span matTextSuffix>%</span>
                      <mat-hint *ngIf="f.ayudaReal" [class.is-aviso]="f.avisoReal">{{ f.ayudaReal }}</mat-hint>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #realLectura>
                    <span class="table-page__text" [class.cierre-bsc__apagado]="!f.vigente">
                      {{ f.vigente ? (f.realInicial ? f.realInicial + "%" : "Sin capturar") : "NA" }}
                    </span>
                  </ng-template>
                </td>

                <td class="cierre-bsc__num cierre-bsc__col-dato">
                  <span class="table-page__text cierre-bsc__apagado">{{ f.pesoTexto }}</span>
                </td>
                <td class="cierre-bsc__num cierre-bsc__col-dato">
                  <strong class="cierre-bsc__calculo">{{ f.ponderadoTexto }}</strong>
                </td>
                <td class="cierre-bsc__num cierre-bsc__col-dato">
                  <strong class="cierre-bsc__calculo" [class.is-bajo]="f.vigente && f.bajoMeta">{{ f.acumTexto }}</strong>
                  <span class="cierre-bsc__bajo bsc-oculto" *ngIf="f.vigente && f.bajoMeta">, por debajo de lo programado</span>
                </td>

                <!-- Resumen de evidencia = comentario del avance del trimestre -->
                <td class="cierre-bsc__col-evidencia">
                  <ng-container *ngIf="f.vigente && capturaHabilitada; else resumenLectura">
                    <mat-form-field appearance="outline" class="table-page__field cierre-bsc__celda" subscriptSizing="dynamic">
                      <textarea matInput [id]="'cierre-bsc-comentario-' + f.idEjercicioKpi" rows="2"
                                [maxlength]="largoComentario" [(ngModel)]="f.comentario" (ngModelChange)="cambia(f)"
                                [disabled]="guardando || loading" placeholder="Qué se logró en el trimestre"
                                [attr.aria-label]="'Resumen de evidencia de Q' + q + ' de ' + f.objetivo"></textarea>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #resumenLectura>
                    <span class="table-page__subtext cierre-bsc__resumen-texto">{{ f.comentarioInicial || "—" }}</span>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- El pie de la maqueta: el alcance del área con lo escrito. -->
        <footer class="cierre-bsc__alcance" *ngIf="pie">
          <div class="cierre-bsc__alcance-dato" aria-live="polite">
            <span>Alcance del área al cierre de Q{{ q }}</span>
            <strong>{{ pie.real }} <small>de {{ pie.programado }} programado</small></strong>
          </div>
          <span class="table-page__status-badge" *ngIf="pie.semaforo" [ngClass]="pie.semaforo.clase">
            <span class="material-icons" aria-hidden="true">{{ pie.semaforo.icono }}</span>
            {{ pie.semaforo.texto }}
          </span>
          <span class="cierre-bsc__alcance-nota" *ngIf="pie.bajoMeta > 0">
            {{ pie.bajoMeta }} {{ pie.bajoMeta === 1 ? "KPI queda" : "KPIs quedan" }} por debajo de lo programado: se
            pedirá comentario al enviar.
          </span>
        </footer>

        <div class="cierre-bsc__mensajes">
          <output class="bsc-mensajes bsc-mensajes--aviso d-block" *ngIf="avisosGuardado.length > 0">
            <h3>
              <span class="material-icons" aria-hidden="true">info</span>
              Se guardó, con {{ avisosGuardado.length === 1 ? "un aviso" : avisosGuardado.length + " avisos" }}
            </h3>
            <ul>
              <li *ngFor="let a of avisosGuardado; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
            </ul>
          </output>
          <p class="cierre-bsc__error" role="alert" [class.is-lleno]="!!errorGuardado || recargar">
            {{ errorGuardado }}
            <button type="button" mat-raised-button class="btn table-page__primary-btn cierre-bsc__recargar"
                    *ngIf="recargar" (click)="recargarPantalla()">
              <span class="material-icons" aria-hidden="true">refresh</span>
              Recargar
            </button>
          </p>
        </div>

        <footer class="cierre-bsc__pie">
          <span class="cierre-bsc__pie-texto is-error" id="cierre-bsc-razon-2" *ngIf="textoPasoAvance">{{ textoPasoAvance }}</span>
          <div class="cierre-bsc__pie-acciones">
            <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                    [disabled]="guardando" (click)="atras()">
              <span class="material-icons" aria-hidden="true">arrow_back</span>
              Meses
            </button>
            <button type="button" mat-raised-button
                    class="btn table-page__icon-btn table-page__icon-btn--secondary cierre-bsc__guardar"
                    *ngIf="capturaHabilitada" [disabled]="guardando || loading" [attr.aria-busy]="guardando"
                    (click)="guardarBorrador()">
              <span class="material-icons" aria-hidden="true">save</span>
              {{ guardando ? "Guardando…" : "Guardar borrador" }}
            </button>
            <button type="button" mat-raised-button class="btn table-page__primary-btn cierre-bsc__continuar"
                    [disabled]="!puedeSeguirAvance"
                    [attr.aria-describedby]="textoPasoAvance ? 'cierre-bsc-razon-2' : null" (click)="aConfirmar()">
              Continuar a confirmar
              <span class="material-icons" aria-hidden="true">arrow_forward</span>
            </button>
          </div>
        </footer>
      </section>

      <!-- ============================ 3 · Confirmar y enviar ============================ -->
      <ng-container *ngIf="modo === 'CIERRE' && paso === 3">
        <section class="table-page__card bsc-bloque cierre-bsc__paso" aria-labelledby="cierre-bsc-paso-3">
          <header class="bsc-bloque__encabezado">
            <h2 id="cierre-bsc-paso-3" tabindex="-1">3 · Confirmar y enviar Q{{ q }}</h2>
            <p>Lo que recibe Dirección, como lo calcula el servidor. Al enviarlo, Q{{ q }} ya no se captura mientras lo revisa.</p>
          </header>

          <dl class="bsc-datos">
            <div>
              <dt>Alcance del área al cierre de Q{{ q }}</dt>
              <dd>
                {{ alcance }}
                <span class="table-page__status-badge" *ngIf="semaforoArea" [ngClass]="semaforoArea.clase">
                  <span class="material-icons" aria-hidden="true">{{ semaforoArea.icono }}</span>
                  {{ semaforoArea.texto }}
                </span>
              </dd>
            </div>
            <div>
              <dt>KPIs vigentes</dt>
              <dd>{{ kpisVigentes }} · {{ mesesVigentes - mesesFaltantes }} de {{ mesesVigentes }} meses</dd>
            </div>
            <div>
              <dt>Límite de envío</dt>
              <dd>{{ limiteEnvio || "Sin fecha límite" }}</dd>
            </div>
            <div>
              <dt>Estatus</dt>
              <dd>
                <span class="table-page__status-badge" *ngIf="estatus" [ngClass]="estatus.clase">
                  <span class="material-icons" aria-hidden="true">{{ estatus.icono }}</span>
                  {{ estatus.texto }}
                </span>
              </dd>
            </div>
          </dl>

          <!-- Lo que impide enviar (servidor). -->
          <div class="bsc-mensajes bsc-mensajes--error" *ngIf="faltantes.length > 0">
            <h3>
              <span class="material-icons" aria-hidden="true">block</span>
              Lo que impide enviar ({{ faltantes.length }})
            </h3>
            <ul>
              <li *ngFor="let f of faltantes; trackBy: trackMensaje" [attr.title]="f.codigo || null">{{ f.texto }}</li>
            </ul>
            <div class="cierre-bsc__mensajes-acciones">
              <ng-container *ngIf="hayFaltaDeCaptura">
                <button type="button" class="table-page__link cierre-bsc__boton-enlace" (click)="irA(1)">Revisar los meses</button>
                <button type="button" class="table-page__link cierre-bsc__boton-enlace" (click)="irA(2)">Revisar el avance real</button>
              </ng-container>
              <a class="table-page__link" *ngIf="hayFaltaDeFechas && puedeConfigurar" [routerLink]="ruta.parametros">
                Capturar la fecha en Parámetros
              </a>
              <span class="bsc-nota" *ngIf="hayFaltaDeFechas && !puedeConfigurar">La fecha la captura Calidad en Parámetros.</span>
            </div>
          </div>

          <!-- Lo que solo se avisa (MESES_INCOMPLETOS, ENVIO_FUERA_DE_FECHA, PROGRAMADO_CERO…). -->
          <div class="bsc-mensajes bsc-mensajes--aviso" *ngIf="avisos.length > 0">
            <h3>
              <span class="material-icons" aria-hidden="true">info</span>
              Para tomar en cuenta ({{ avisos.length }})
            </h3>
            <ul>
              <li *ngFor="let a of avisos; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
            </ul>
          </div>

          <!-- Los KPI bajo el verde: con alguno, el comentario es obligatorio. -->
          <div class="cierre-bsc__bajo-meta" *ngIf="bajoMeta.length > 0">
            <h3>
              <span class="material-icons" aria-hidden="true">trending_down</span>
              {{ bajoMeta.length }} {{ bajoMeta.length === 1 ? "KPI queda" : "KPIs quedan" }} por debajo de lo programado
            </h3>
            <ul>
              <li *ngFor="let k of bajoMeta; trackBy: trackFila">
                <strong>{{ k.objetivo }}</strong>
                <span>{{ k.texto }}</span>
              </li>
            </ul>
          </div>

          <div class="cierre-bsc__comentario">
            <p class="bsc-nota" *ngIf="trimestre?.comentarioEnvio && trimestre?.estatus === 'REGRESADO'">
              Comentario del envío anterior: «{{ trimestre?.comentarioEnvio }}»
            </p>
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Comentario para Dirección{{ comentarioObligatorio ? "" : " (opcional)" }}</mat-label>
              <textarea matInput id="cierre-bsc-comentario-envio" rows="3" [maxlength]="largoComentario"
                        [required]="comentarioObligatorio" [(ngModel)]="comentario" [disabled]="enviando || !puedeCerrar"
                        [attr.aria-label]="'Comentario para Dirección' + (comentarioObligatorio ? '' : ' (opcional)')"
                        aria-describedby="cierre-bsc-comentario-ayuda"></textarea>
              <mat-hint id="cierre-bsc-comentario-ayuda">
                {{ comentarioObligatorio
                  ? "Obligatorio: explica por qué " + (bajoMeta.length === 1 ? "el KPI queda" : "los KPI quedan") + " por debajo de lo programado."
                  : "Lo lee Dirección al revisar; queda en la bitácora." }}
              </mat-hint>
              <mat-hint align="end">{{ comentario.length }}/{{ largoComentario }}</mat-hint>
            </mat-form-field>
          </div>

          <p class="cierre-bsc__error cierre-bsc__error-envio" role="alert" tabindex="-1"
             [class.is-lleno]="!!errorEnvio || recargar">
            {{ errorEnvio }}
            <a class="table-page__link" *ngIf="errorDeFechas && puedeConfigurar" [routerLink]="ruta.parametros">Ir a Parámetros</a>
            <button type="button" mat-raised-button class="btn table-page__primary-btn cierre-bsc__recargar"
                    *ngIf="recargar" (click)="recargarPantalla()">
              <span class="material-icons" aria-hidden="true">refresh</span>
              Recargar
            </button>
          </p>

          <footer class="cierre-bsc__pie">
            <span class="cierre-bsc__pie-texto" id="cierre-bsc-razon-3" *ngIf="razonNoEnvio">{{ razonNoEnvio }}</span>
            <div class="cierre-bsc__pie-acciones">
              <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                      [disabled]="enviando" (click)="atras()">
                <span class="material-icons" aria-hidden="true">arrow_back</span>
                Avance real
              </button>
              <button type="button" mat-raised-button class="btn table-page__primary-btn cierre-bsc__enviar"
                      [disabled]="!puedeEnviar" [attr.aria-busy]="enviando"
                      [attr.aria-describedby]="razonNoEnvio ? 'cierre-bsc-razon-3' : null" (click)="enviar()">
                <span class="material-icons" aria-hidden="true">send</span>
                {{ enviando ? "Enviando…" : "Enviar a revisión" }}
              </button>
            </div>
          </footer>
        </section>
      </ng-container>

      <!-- ============================ Resultado: enviado o autorizado ============================ -->
      <section class="table-page__card bsc-bloque cierre-bsc__resultado" *ngIf="resultado as r"
               aria-labelledby="cierre-bsc-resultado">
        <header class="bsc-bloque__encabezado cierre-bsc__resultado-encabezado">
          <span class="cierre-bsc__resultado-icono material-icons" aria-hidden="true">{{ r.icono }}</span>
          <div>
            <h2 id="cierre-bsc-resultado" tabindex="-1">{{ r.titulo }}</h2>
            <p>{{ r.siguiente }}</p>
          </div>
          <span class="table-page__status-badge" *ngIf="r.estatus" [ngClass]="r.estatus.clase">
            <span class="material-icons" aria-hidden="true">{{ r.estatus.icono }}</span>
            {{ r.estatus.texto }}
          </span>
        </header>

        <dl class="bsc-datos">
          <div *ngFor="let d of r.datos; trackBy: trackDato">
            <dt>{{ d.etiqueta }}</dt>
            <dd>
              {{ d.valor }}
              <span class="table-page__status-badge" *ngIf="d.badge" [ngClass]="d.badge.clase">
                <span class="material-icons" aria-hidden="true">{{ d.badge.icono }}</span>
                {{ d.badge.texto }}
              </span>
            </dd>
          </div>
        </dl>

        <div class="cierre-bsc__comentario-enviado" *ngIf="r.comentario">
          <h3>{{ r.comentarioTitulo }}</h3>
          <p>«{{ r.comentario }}»</p>
        </div>

        <div class="cierre-bsc__bajo-meta" *ngIf="bajoMeta.length > 0">
          <h3>
            <span class="material-icons" aria-hidden="true">trending_down</span>
            {{ bajoMeta.length }} {{ bajoMeta.length === 1 ? "KPI quedó" : "KPIs quedaron" }} por debajo de lo programado
          </h3>
          <ul>
            <li *ngFor="let k of bajoMeta; trackBy: trackFila">
              <strong>{{ k.objetivo }}</strong>
              <span>{{ k.texto }}</span>
            </li>
          </ul>
        </div>

        <div class="bsc-mensajes bsc-mensajes--aviso" *ngIf="avisos.length > 0">
          <h3>
            <span class="material-icons" aria-hidden="true">info</span>
            Para tomar en cuenta
          </h3>
          <ul>
            <li *ngFor="let a of avisos; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
          </ul>
        </div>

        <footer class="cierre-bsc__pie">
          <span></span>
          <div class="cierre-bsc__pie-acciones">
            <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
               *ngIf="verTablero && idBscArea != null" [routerLink]="[ruta.area, idBscArea]" [queryParams]="queryArea">
              <span class="material-icons" aria-hidden="true">insights</span>
              Ver tablero del área
            </a>
            <a mat-raised-button class="btn table-page__primary-btn" [routerLink]="ruta.miBsc" [queryParams]="queryMiBsc">
              <span class="material-icons" aria-hidden="true">assignment_ind</span>
              Volver a Mi BSC
            </a>
          </div>
        </footer>
      </section>
    </ng-container>

    <ng-template #sinKpis>
      <div class="table-page__empty cierre-bsc__sin-kpis">
        <span class="material-icons" aria-hidden="true">playlist_remove</span>
        <h3>La planeación no tiene KPIs activos</h3>
      </div>
    </ng-template>

    <ng-template #volverArea>
      <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
         [routerLink]="[ruta.area, idBscArea]" [queryParams]="queryArea">
        <span class="material-icons" aria-hidden="true">arrow_back</span>
        Detalle del área
      </a>
    </ng-template>
  </div>
</div>
